import React, { ChangeEvent, useEffect, useState } from "react";
import cn from "classnames";
import Textarea from "react-expanding-textarea"
import styles from "./input-cell.module.scss";

interface ITextEditableCellProps {
    value?: string;
    className?: string;
    onChange: (value: string) => void;
    onPaste: (value: string[][]) => void;
    readonly: boolean;
}

export const InputCell: React.FC<ITextEditableCellProps> = ({
                                                                value,
                                                                onChange,
                                                                onPaste,
                                                                readonly,
                                                                className
                                                            }) => {
    const [text, setText] = useState<string>(value ?? "");

    useEffect(() => {
        if (text !== value) {
            setText(value ?? "");
        }
    }, [value]);

    const handlePaste = (e: any) => {
        const pasteText = e.clipboardData.getData("text");
        const paste = pasteText.split(/\r?\n|\r/).map((i: string) => i.split(/\t/));
        const pasteCols = paste[0].length;
        // есть неразрешимое противоречие -
        // текст без табуляций с переводами строк
        // можно вставить в ячейку целиком или разбить на строки,
        // текущее решение - вставлять целиком
        if (pasteCols < 2) return; // уходим в обработчик вставки по умолчанию
        else {
            e.preventDefault();
            onPaste(paste);
        }
    };

    const handleInputChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        const value = e.target.value;
        setText(value);
        onChange(value);
    };

    return (
        <div className={cn(styles.container, className)}>
            <Textarea
                className={styles.input}
                value={text}
                disabled={readonly}
                onChange={handleInputChange}
                onPaste={(e) => {
                    handlePaste(e);
                }}
            />
        </div>
    );
};
